import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withSnackbar } from "notistack";
import { isMobile, isMobileOnly, isTablet } from "react-device-detect";
import { startLoadingAnimate, stopLoadingAnimate, } from "services/ducks/loading";
import SubdirectoryArrowRightIcon from '@material-ui/icons/SubdirectoryArrowRight';
import HelpIcon from '@material-ui/icons/Help';
import { Row, Col } from "react-bootstrap";
import * as FontAwesome from "@fortawesome/react-fontawesome";
import { Slider, TextField, Checkbox, FormControlLabel, Table, TableContainer, TableHead, TableBody, TableRow, TableCell, Button } from "@material-ui/core";
import { faSave } from "@fortawesome/free-regular-svg-icons";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons"
import { ContainerTitle, FullSizedButton } from "../styles";
import { DeclaracaoSubtitle, SessionTitle, ValorContribuicoes, Separador, AlinhadorTotal, AlinhadorSliderContribuicaoVoluntaria } from "./styles";
import NumberFormat from "react-number-format";
import api from "services/structure/api";
import { numberFormatter } from "services/structure/numberUtils";
import { DatePicker } from "components";
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';

class MeuPlanoAlterarContribuicao extends Component {

  state = {
    parametros: {}
  }

  meses = [
    "Janeiro",
    "Fevereiro",
    "Março",
    "Abril",
    "Maio",
    "Junho",
    "Julho",
    "Agosto",
    "Setembro",
    "Outubro",
    "Novembro",
    "Dezembro"
  ]

  mesesSigla = [
    "Jan",
    "Fev",
    "Mar",
    "Abr",
    "Mai",
    "Jun",
    "Jul",
    "Ago",
    "Set",
    "Out",
    "Nov",
    "Dez"
  ]


  downloadParametrosContribuicao() {
    return api.get("/usuario/contribuicao/parametros")
      .then(response => {
        const parametros = response.data;
        parametros.dataContratacaoContribuicaoVoluntariaMensal = this.dateConstructorFromTimestamp(parametros.dataContratacaoContribuicaoVoluntariaMensal);
        parametros.dataCancelamentoVoluntariaMensal = this.dateConstructorFromTimestamp(parametros.dataCancelamentoVoluntariaMensal);
        this.setState({ parametros: parametros });
        this.props.stopLoadingAnimate();
      })
      .catch((e) => {
        const mensagem = "Não foi possível conectar-se ao servidor. Recarregue a página! ";
        this.props.enqueueSnackbar(mensagem, { variant: 'error' });
        console.log(e);
      });
  }

  downloadHistoricoContribuicao() {
    return api.get("/usuario/contribuicao/parametros/historico")
      .then(response => {
        const historicoAlteracoes = response.data;
        this.setState({ historicoAlteracoes: historicoAlteracoes });
      })
      .catch((e) => {
        const mensagem = "Não foi possível conectar-se ao servidor. Recarregue a página! ";
        this.props.enqueueSnackbar(mensagem, { variant: 'error' });
        console.log(e);
      });
  }

  componentDidMount() {
    this.props.startLoadingAnimate();
    const promises = [];
    promises.push(this.downloadParametrosContribuicao());
    promises.push(this.downloadHistoricoContribuicao());


    Promise.all(promises)
      .finally(() => this.props.stopLoadingAnimate());

    window.scrollTo(0, 0);
  }

  navigateTo(route) {
    this.props.history.push(route);
  }

  dateConstructorFromTimestamp = timestamp => {
    if (!timestamp) {
      return null;
    }
    return new Date(timestamp);
  }

  // TODO levar isso ao number utils
  converterDecimalEmPercentual = (val) => {
    return val * 100;
  }

  formatarPercentual = (defaultProperty) => {
    return (val) => {
      if (Number.isNaN(val)) {
        val = this.converterDecimalEmPercentual(this.state.parametros[defaultProperty]);
      }
      if (Number.isNaN(val)) {
        return '';
      }
      return numberFormatter.format(val) + '%';
    }
  }

  converterDecimalEmPercentualFormatado = nomeAtributo => {
    let val = this.state.parametros[nomeAtributo + 'InputText'];
    if (val != null) {
      return val;
    }
    val = this.state.parametros[nomeAtributo];
    if (Number.isNaN(val)) {
      return '';
    }
    return numberFormatter.format(this.converterDecimalEmPercentual(val));
  }

  converterPercentualFormatadoEmDecimal = (val) => {
    val = val.replace(/[^\d|,]/g, '');
    return this.converterPercentualEmDecimal(numberFormatter.unformat(val));
  }

  converterPercentualEmDecimal = (val) => {
    return val / 100;
  }

  changePercentualContribuicaoSlider = (nomeAtributo, novoValor, calcularParametrosContribuicaoAbsolutos) => {
    let parametros = this.state.parametros;
    const novoPercentualConvertido = this.converterPercentualEmDecimal(novoValor);
    parametros[nomeAtributo] = novoPercentualConvertido;
    const nomeAtributoValorAbsoluto = this.obterNomeAtributoValorAbsoluto(nomeAtributo);
    parametros[nomeAtributo + 'InputText'] = null;
    parametros = calcularParametrosContribuicaoAbsolutos(parametros, nomeAtributoValorAbsoluto, novoPercentualConvertido);
    this.setState({ parametros: parametros });
  }

  calcularValorVoluntaria = (parametros, nomeAtributo, novoPercentualConvertido) => {
    parametros[nomeAtributo] = novoPercentualConvertido * parametros.salarioParticipacao;
    parametros.contribuicaoAtualNormal = parametros.parcela1 + parametros.parcela2;
    return parametros;
  }

  deveCalcularP2 = () => {
    return this.state.parametros.permitirEdicaoPercentualContribuicaoParcela2;
  }

  calcularValorP2 = (parametros, nomeAtributo, novoPercentualConvertido) => {
    if (!this.deveCalcularP2()) {
      parametros[nomeAtributo] = 0;
    } else {
      let salarioBase = this.state.parametros.salarioParticipacao - this.state.parametros.unidadePrevidenciaria;
      parametros[nomeAtributo] = novoPercentualConvertido * salarioBase;
    }
    parametros.contribuicaoAtualNormal = parametros.parcela1 + parametros.parcela2;

    return parametros;
  }

  calcularValorP1 = (parametros, nomeAtributo, novoPercentualConvertido) => {
    let nomePlano = this.props.authData.usuario.pessoa.nomePlano
    let isPlano2 = nomePlano === "CuritibaPrevPlan 2"

    let salarioBase = isPlano2 ? parametros.salarioParticipacao : Math.min(parametros.salarioParticipacao, parametros.unidadePrevidenciaria)
    parametros[nomeAtributo] = novoPercentualConvertido * salarioBase;
    parametros.contribuicaoAtualNormal = parametros.parcela1 + parametros.parcela2;

    return parametros;
  }

  changePercentualContribuicaoTextField = (nomeAtributo, calcularParametrosContribuicaoAbsolutos) => {
    const nomeAtributoValorAbsoluto = this.obterNomeAtributoValorAbsoluto(nomeAtributo);
    return e => {
      let parametros = this.state.parametros;
      let novoPercentualConvertido = this.converterPercentualFormatadoEmDecimal(e.target.value);
      parametros[nomeAtributo + 'InputText'] = e.target.value;
      parametros[nomeAtributo] = novoPercentualConvertido;
      if (novoPercentualConvertido > 1) {
        novoPercentualConvertido = 1;
        parametros[nomeAtributo + 'InputText'] = 100;
      }
      parametros = calcularParametrosContribuicaoAbsolutos(parametros, nomeAtributoValorAbsoluto, novoPercentualConvertido);
      this.setState(parametros)
    }
  }

  obterNomeAtributoValorAbsoluto = (nomeAtributo) => {
    switch (nomeAtributo) {
      case 'percentualParcela1': return 'parcela1';
      case 'percentualParcela2': return 'parcela2';
      case 'percentualContribuicaoVoluntaria': return 'contribuicaoVoluntaria';
      default: return '';
    }
  }

  validateValorParcela1 = () => {
    let valorMin = this.state.parametros.valorMinimoParcela1ValorAbsoluto;
    let val = this.state.parametros.valorParcela1;
    if (val < valorMin) {
      const mensagem = "O valor da Contribuição Mensal deve ser de no mínimo R$" + numberFormatter.format(valorMin) + ".";
      this.props.enqueueSnackbar(mensagem, { variant: 'error' });
      return false;
    }
    return true;
  }

  validatePercentualParcela1 = () => {
    const parametros = this.state.parametros;
    if (!parametros.permitirEdicaoPercentualContribuicaoParcela1) {
      return true;
    }
    const valorMin = parametros.minPercentualParcela1;
    const valorMax = parametros.maxPercentualParcela1;
    let val = parametros.percentualParcela1;
    if (val < valorMin || val > valorMax) {
      const mensagem = `O percentual de Contribuição ${this.state.parametros.lblAreaParticipanteParcela1} deve ser entre ${numberFormatter.format(valorMin * 100)}% e ${numberFormatter.format(valorMax * 100)}%.`;
      this.props.enqueueSnackbar(mensagem, { variant: 'error' });
      val = val < valorMin ? valorMin : valorMax;
      parametros.percentualParcela1 = val < valorMin ? valorMin : valorMax;
      parametros.percentualParcela1InputText = numberFormatter.format(this.converterDecimalEmPercentual(val));
      this.setState({ parametros: parametros });
      return false;
    }
    return true;
  }

  validatePercentualParcela2 = () => {
    const parametros = this.state.parametros;
    if (!this.deveCalcularP2()) {
      return true;
    }
    const valorMin = parametros.minPercentualParcela2;
    const valorMax = parametros.maxPercentualParcela2;
    let val = parametros.percentualParcela2;
    if (val < valorMin || val > valorMax) {
      const mensagem = `O percentual de Contribuição ${this.state.parametros.lblAreaParticipanteParcela2} deve ser entre ${numberFormatter.format(valorMin * 100)}% e ${numberFormatter.format(valorMax * 100)}%.`;
      this.props.enqueueSnackbar(mensagem, { variant: 'error' });
      val = val < valorMin ? valorMin : valorMax;
      parametros.percentualParcela2 = val < valorMin ? valorMin : valorMax;
      parametros.percentualParcela2InputText = numberFormatter.format(this.converterDecimalEmPercentual(val));
      this.setState({ parametros: parametros });
      return false;
    }
    return true;
  }

  changeValorAtributoNumerico = (nomeAtributo, e) => {
    let val = numberFormatter.unformat(isNaN(e.floatValue) ? 0 : e.floatValue);
    if (!Number.isNaN(val)) {
      const parametros = this.state.parametros;
      parametros[nomeAtributo] = val
      this.setState({ parametros: parametros });
    }
  }

  changeCheckboxMesesContratacaoVoluntariaMensal = (idx, e) => {
    const parametros = this.state.parametros;
    parametros.mesesContratacaoVoluntariaMensal[idx] = e.target.checked;
    this.setState({ parametros: parametros });
  }

  checkTodosMesesContratacaoVoluntariaMensal = e => {
    const parametros = this.state.parametros;
    for (let i = 0; i < parametros.mesesContratacaoVoluntariaMensal.length; i++) {
      parametros.mesesContratacaoVoluntariaMensal[i] = e.target.checked;
    }
    this.setState({ parametros: parametros });
  }

  setStateOnValueChange = (key, value) => {
    const parametros = this.state.parametros;
    parametros[key] = value;
    this.setState({ parametros: parametros });
  }

  salvarParametrosContribuicao = () => {
    const parametros = this.state.parametros;
    const payload = {};
    let valid = true;

    if (parametros.contribuicaoValorAbsoluto) {
      valid &= this.validateValorParcela1();
      payload.valorParcela1 = Number.parseFloat(numberFormatter.unformat(parametros.valorParcela1));
      payload.valorContribuicaoVoluntaria = Number.parseFloat(numberFormatter.unformat(parametros.valorContribuicaoVoluntaria));
      if (parametros.dataContratacaoContribuicaoVoluntariaMensal) {
        payload.dataContratacaoContribuicaoVoluntariaMensal = parametros.dataContratacaoContribuicaoVoluntariaMensal;
      }
      if (parametros.dataCancelamentoVoluntariaMensal) {
        payload.dataCancelamentoVoluntariaMensal = parametros.dataCancelamentoVoluntariaMensal;
      }
      payload.mesesContratacaoVoluntariaMensal = parametros.mesesContratacaoVoluntariaMensal;
    } else {
      valid &= this.validatePercentualParcela1();
      valid &= this.validatePercentualParcela2();
      payload.percentualParcela2 = parametros.percentualParcela2;
      payload.percentualContribuicaoVoluntaria = parametros.percentualContribuicaoVoluntaria;
      if (parametros.permitirEdicaoPercentualContribuicaoParcela1) {
        payload.percentualParcela1 = parametros.percentualParcela1;
      }
    }

    if (!valid) {
      return;
    }

    this.props.startLoadingAnimate();
    api.put("/usuario/contribuicao/parametros", payload)
      .then(() => {
        this.props.stopLoadingAnimate();
        const mensagem = "Contribuição alterada com sucesso! ";
        this.props.enqueueSnackbar(mensagem, { variant: 'success' });
        this.downloadParametrosContribuicao();
        this.downloadHistoricoContribuicao().finally(() => this.props.stopLoadingAnimate());
      })
      .catch((e) => {
        let mensagem = "Não foi possível conectar-se ao servidor. Tente novamente! ";
        if (e?.response?.data?.message) {
          mensagem = e.response.data.message;
        }
        this.props.enqueueSnackbar(mensagem, { variant: 'error' });
        console.log(e);
      })
      .finally(() => {
        this.props.stopLoadingAnimate()
      });
  }


  validarPatchValorPercentual = payload => {
    let isValid = true;
    if (payload.contribuicaoVoluntaria < this.state.parametros.minPercentualContribuicaoVoluntariaSobreUP) {
      isValid = false;
      this.props.enqueueSnackbar("Contribuição voluntária deve ser maior que R$ " + numberFormatter.format(this.state.parametros.minPercentualContribuicaoVoluntariaSobreUP), { variant: 'error' });
    }
    return isValid;
  }

  // FIXME: Trazer esse texto do backend, ou usar uma flag para diferenciar os textos
  descricaoParcela1 = () => {
    let nomePlano = this.props.authData.usuario.pessoa.nomePlano
    let textoTooltip = ""

    if (nomePlano === "CuritibaPrevPlan 1") {
      let percentualPadrao = this.converterDecimalEmPercentualFormatado('percentualParcela1Padrao');
      textoTooltip = `Igual a ${percentualPadrao}% da parcela do Salário de Participação abaixo de 1 UP`;
    } else {
      textoTooltip = `Percentual escolhido pelo Participante de até 10,50%`;
    }

    return textoTooltip;
  }

  renderResumoParametrosContribuicaoPercentual = () => {
    return (
      <DeclaracaoSubtitle>
        <span>
          Salário de Participação: <NumberFormat
            value={this.state.parametros.salarioParticipacao}
            displayType={"text"}
            thousandSeparator="."
            decimalSeparator=","
            decimalScale={2}
            fixedDecimalScale={true}
            prefix={"R$ "}
          />
          <br />
        </span>
        {false && <Row>
          <span>
            Unidade Previdenciária (UP): <NumberFormat
              value={this.state.parametros.unidadePrevidenciaria}
              displayType={"text"}
              thousandSeparator="."
              decimalSeparator=","
              decimalScale={2}
              fixedDecimalScale={true}
              prefix={"R$ "}
            />
            <br />
          </span>
        </Row>
        }
        <span>
          Contribuição Vigente Normal: <NumberFormat
            value={this.state.parametros.contribuicaoVigenteNormal}
            displayType={"text"}
            thousandSeparator="."
            decimalSeparator=","
            decimalScale={2}
            fixedDecimalScale={true}
            prefix={"R$ "}
          />
          <OverlayTrigger placement={isMobile ? "bottom" : "right"}
            overlay={
              <Tooltip className='help-button'>
                {this.descricaoParcela1()}
              </Tooltip>
            }>
            <HelpIcon className="help-icon-parcela-1"></HelpIcon>
          </OverlayTrigger>
          <br />
        </span>
        {false && <Row>
          <span>
            <SubdirectoryArrowRightIcon> </SubdirectoryArrowRightIcon>
            {this.state.parametros.lblAreaParticipanteParcela1}: <NumberFormat
              value={this.state.parametros.parcela1Vigente}
              displayType={"text"}
              thousandSeparator="."
              decimalSeparator=","
              decimalScale={2}
              fixedDecimalScale={true}
              prefix={"R$ "}
            />
            <OverlayTrigger placement={isMobile ? "bottom" : "right"}
              overlay={
                <Tooltip className='help-button'>
                  {this.descricaoParcela1()}
                </Tooltip>
              }>
              <HelpIcon className="help-icon-parcela-1"></HelpIcon>
            </OverlayTrigger>
            <br />
          </span>
        </Row>
        }
        <div>
          {this.state.parametros.exibirPercentualContribuicaoParcela2 &&
            <Row>
              <span >
                <SubdirectoryArrowRightIcon> </SubdirectoryArrowRightIcon>
                {this.state.parametros.lblAreaParticipanteParcela2}: <NumberFormat
                  value={this.state.parametros.parcela2Vigente}
                  displayType={"text"}
                  thousandSeparator="."
                  decimalSeparator=","
                  decimalScale={2}
                  fixedDecimalScale={true}
                  prefix={"R$ "}
                />
                <OverlayTrigger placement={isMobile ? "bottom" : "right"}
                  overlay={
                    <Tooltip className='help-button'>
                      {this.state.parametros.hintParcela2}
                    </Tooltip>
                  }>
                  <HelpIcon className="help-icon-parcela-1"></HelpIcon>
                </OverlayTrigger>
                <br />
              </span>
            </Row>
          }
          {false && <Row>
            <span>
              Contribuição Vigente Voluntária: <NumberFormat
                value={this.state.parametros.contribuicaoVigenteVoluntaria}
                displayType={"text"}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={2}
                fixedDecimalScale={true}
                prefix={"R$ "}
              />
              <br />
            </span>
          </Row>
          }
        </div>
      </DeclaracaoSubtitle>
    )
  }

  renderResumoParametrosContribuicaoValorAbsoluto = () => {
    return (
      <DeclaracaoSubtitle>
        <span>
          Contribuição Atual: <NumberFormat
            value={this.state.parametros.contribuicaoVigenteNormal}
            displayType={"text"}
            thousandSeparator="."
            decimalSeparator=","
            decimalScale={2}
            fixedDecimalScale={true}
            prefix={"R$ "}
          />
          <br />
        </span>
        <span>
          Contribuição Voluntária Atual: <NumberFormat
            value={this.state.parametros.contribuicaoVigenteVoluntaria}
            displayType={"text"}
            thousandSeparator="."
            decimalSeparator=","
            decimalScale={2}
            fixedDecimalScale={true}
            prefix={"R$ "}
          />
          <br />
        </span>
      </DeclaracaoSubtitle>
    )
  }

  renderEdicaoContribuicaoNormalPercentual = () => {
    return (
      <div className="contribuicao-normal">
        <SessionTitle>CONTRIBUIÇÃO NORMAL</SessionTitle>
        {
          !isMobile &&
          <Row>
            <Col sm={12}>
              <AlinhadorSliderContribuicaoVoluntaria></AlinhadorSliderContribuicaoVoluntaria>
            </Col>
          </Row>
        }
        {
          !isMobile && this.state.parametros.exibirPercentualContribuicaoParcela2 &&
          <Row>
            <Col sm={12}>
              <ValorContribuicoes>
                {this.state.parametros.lblAreaParticipanteParcela2}: <NumberFormat
                  value={this.state.parametros.parcela2}
                  displayType={"text"}
                  thousandSeparator="."
                  decimalSeparator=","
                  decimalScale={2}
                  fixedDecimalScale={true}
                  prefix={"R$ "}
                /></ValorContribuicoes>
            </Col>
          </Row>
        }
        {
          this.state.parametros.permitirEdicaoPercentualContribuicaoParcela1 &&
          <Row>
            <Col sm={isTablet ? 8 : 12} >
              <span className="slider-component">
                <Slider value={this.converterDecimalEmPercentual(this.state.parametros.percentualParcela1)}
                  onChange={(_, newValue) => this.changePercentualContribuicaoSlider('percentualParcela1', newValue, this.calcularValorP1)}
                  min={this.state.parametros.minPercentualParcela1 * 100}
                  max={this.state.parametros.maxPercentualParcela1 * 100} size='large'
                  step={0.25} valueLabelFormat={this.formatarPercentual('percentualParcela1')}
                />
              </span>
              <div className="input-text-percent">
                <TextField
                  variant="outlined"
                  margin="normal"
                  label={this.state.parametros.lblAreaParticipanteParcela1}
                  className="slider-percent-input"
                  onChange={this.changePercentualContribuicaoTextField('percentualParcela1', this.calcularValorP1)}
                  onBlur={() => this.validatePercentualParcela1()}
                  value={this.converterDecimalEmPercentualFormatado('percentualParcela1')}
                />
                <span className="input-percent-suffix">%</span>
              </div>
            </Col>
            {
              isMobile &&
              <Col sm={3}>
                <DeclaracaoSubtitle className="total">
                  TOTAL: <NumberFormat
                    value={this.state.parametros.parcela1}
                    displayType={"text"}
                    thousandSeparator="."
                    decimalSeparator=","
                    decimalScale={2}
                    fixedDecimalScale={true}
                    prefix={"R$ "}
                  />
                </DeclaracaoSubtitle>
              </Col>
            }
            {
              this.state.parametros.exibirPercentualContribuicaoParcela2 && this.deveCalcularP2() &&
              <Separador>&nbsp;</Separador>
            }
          </Row>
        }
        {
          this.state.parametros.exibirPercentualContribuicaoParcela2 && this.deveCalcularP2() &&
          <Row>
            <Col sm={isTablet ? 8 : 12} >
              <span className="slider-component">
                <Slider value={this.converterDecimalEmPercentual(this.state.parametros.percentualParcela2)}
                  onChange={(_, newValue) => this.changePercentualContribuicaoSlider('percentualParcela2', newValue, this.calcularValorP2)}
                  min={this.state.parametros.minPercentualParcela2 * 100}
                  max={this.state.parametros.maxPercentualParcela2 * 100}
                  step={0.25} valueLabelFormat={this.formatarPercentual('percentualParcela2')}
                />
              </span>
              <span className="input-text-percent">
                <TextField
                  variant="outlined"
                  margin="normal"
                  label={this.state.parametros.lblAreaParticipanteParcela2}
                  className="slider-percent-input"
                  onChange={this.changePercentualContribuicaoTextField('percentualParcela2', this.calcularValorP2)}
                  onBlur={() => this.validatePercentualParcela2()}
                  value={this.converterDecimalEmPercentualFormatado('percentualParcela2')}
                />
                <span className="input-percent-suffix">%</span>
              </span>
            </Col>
            {
              isMobile &&
              <Col sm={3}>
                <DeclaracaoSubtitle className="total">
                  TOTAL: <NumberFormat
                    value={this.state.parametros.parcela2}
                    displayType={"text"}
                    thousandSeparator="."
                    decimalSeparator=","
                    decimalScale={2}
                    fixedDecimalScale={true}
                    prefix={"R$ "}
                  />
                </DeclaracaoSubtitle>
              </Col>
            }
          </Row>
        }
        {
          !isMobile &&
          !this.state.parametros.exibirPercentualContribuicaoParcela2 && !this.state.parametros.permitirEdicaoPercentualContribuicaoParcela1 &&
          <>
            <Separador>&nbsp;</Separador>
            <Separador>&nbsp;</Separador>
          </>
        }
        {
          !isMobile &&
          <Row>
            <Col sm={12}>
              <DeclaracaoSubtitle className="total">
                TOTAL: <NumberFormat
                  value={this.state.parametros.parcela1 + this.state.parametros.parcela2}
                  displayType={"text"}
                  thousandSeparator="."
                  decimalSeparator=","
                  decimalScale={2}
                  fixedDecimalScale={true}
                  prefix={"R$ "}
                />
              </DeclaracaoSubtitle>
            </Col>
          </Row>
        }
      </div>
    )
  }

  renderEdicaoContribuicaoNormalValorAbsoluto = () => {
    return (
      <div>
        <SessionTitle>CONTRIBUIÇÃO BÁSICA</SessionTitle>
        <Row>
          <Col sm={isTablet ? 12 : 6}>
            <NumberFormat
              value={this.state.parametros.valorParcela1}
              thousandSeparator="."
              decimalSeparator=","
              customInput={TextField}
              onBlur={() => this.validateValorParcela1()}
              onValueChange={e => this.changeValorAtributoNumerico('valorParcela1', e)}
              variant="outlined"
              decimalScale={2}
              fixedDecimalScale={2}
              label="Contribuição"
              prefix={"R$ "}
              fullWidth
            />
          </Col>
        </Row>
      </div>
    )
  }

  renderEdicaoContribuicaoVoluntariaPercentual = () => {
    return (
      <div>
        <Row>
          {
            !isMobile && this.state.parametros.exibirPercentualContribuicaoParcela2 &&
            <Col sm={12}>
              <AlinhadorSliderContribuicaoVoluntaria></AlinhadorSliderContribuicaoVoluntaria>
            </Col>
          }
          <Col sm={isTablet ? 8 : 12} >
            <span className="slider-component">
              <Slider value={this.converterDecimalEmPercentual(this.state.parametros.percentualContribuicaoVoluntaria)}
                onChange={(_, newValue) => this.changePercentualContribuicaoSlider('percentualContribuicaoVoluntaria', newValue, this.calcularValorVoluntaria)}
                min={0} max={100} step={0.05} valueLabelFormat={this.formatarPercentual('percentualContribuicaoVoluntaria')}
              />
            </span>
            <div className="input-text-percent">
              <TextField
                variant="outlined"
                margin="normal"
                label="Percentual"
                className="slider-percent-input"
                onChange={this.changePercentualContribuicaoTextField('percentualContribuicaoVoluntaria', this.calcularValorVoluntaria)}
                value={this.converterDecimalEmPercentualFormatado('percentualContribuicaoVoluntaria')}
              />
              <span className="input-percent-suffix">%</span>
            </div>
          </Col>
          {
            !isMobile && this.state.parametros.exibirPercentualContribuicaoParcela2 && this.state.parametros.permitirEdicaoPercentualContribuicaoParcela1 && this.deveCalcularP2() &&
            <>
              <Separador>&nbsp;</Separador>
              <Col sm={12}>
                <AlinhadorTotal>&nbsp;</AlinhadorTotal>
              </Col>
            </>
          }
          <Col sm={isMobile ? 3 : 12} >
            <DeclaracaoSubtitle className="total">
              TOTAL: <NumberFormat
                value={this.state.parametros.contribuicaoVoluntaria}
                displayType={"text"}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={2}
                fixedDecimalScale={true}
                prefix={"R$ "}
              />
            </DeclaracaoSubtitle>
          </Col>
        </Row>
      </div>
    )
  }

  renderCheckboxesMeses = () => {
    const ret = this.meses.map((mes, idx) => {
      return <span className="alterar-contribuicao-checkbox-meses">
        <FormControlLabel
          control={
            <Checkbox
              checked={this.state.parametros.mesesContratacaoVoluntariaMensal[idx]}
              onChange={e => this.changeCheckboxMesesContratacaoVoluntariaMensal(idx, e)}
              inputProps={{ 'aria-label': 'controlled' }}
            />
          }
          label={mes}
        />
      </span>
    });
    return ret;
  }

  renderEdicaoContribuicaoVoluntariaValorAbsoluto = () => {
    return (
      <div>
        <Row>
          <Col sm={isTablet ? 6 : 4}>
            <Row>
              <Col sm={12}>
                <NumberFormat
                  value={this.state.parametros.valorContribuicaoVoluntaria}
                  thousandSeparator="."
                  decimalSeparator=","
                  customInput={TextField}
                  onBlur={() => this.validateValorParcela1()}
                  onValueChange={e => this.changeValorAtributoNumerico('valorContribuicaoVoluntaria', e)}
                  variant="outlined"
                  decimalScale={2}
                  fixedDecimalScale={2}
                  label="Contribuição"
                  margin="normal"
                  prefix={"R$ "}
                  fullWidth
                />
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <DatePicker
                  variant="outlined"
                  margin="normal"
                  label="Data Início"
                  fullWidth
                  value={this.state.parametros.dataContratacaoContribuicaoVoluntariaMensal}
                  onChange={(date) => this.setStateOnValueChange('dataContratacaoContribuicaoVoluntariaMensal', date)}
                  name="dataInicioContribuicaoVoluntaria" />
              </Col>
              <Col sm={6}>
                <DatePicker
                  variant="outlined"
                  margin="normal"
                  label="Data Fim"
                  fullWidth
                  value={this.state.parametros.dataCancelamentoVoluntariaMensal}
                  onChange={(date) => this.setStateOnValueChange('dataCancelamentoVoluntariaMensal', date)}
                  name="dataFimContribuicaoVoluntaria" />
              </Col>
            </Row>
          </Col>
          <Col sm={isTablet ? 12 : 7}>
            <div className="div-alterar-contribuicao-checkbox-meses">
              <div>
                <b>Em quais meses?</b>
              </div>
              {this.renderCheckboxesMeses()}
              <span className="alterar-contribuicao-checkbox-meses">
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={this.state.parametros.mesesContratacaoVoluntariaMensal.reduce((a, b) => a & b)}
                      onChange={e => this.checkTodosMesesContratacaoVoluntariaMensal(e)}
                      inputProps={{ 'aria-label': 'controlled' }}
                    />
                  }
                  label="Selecionar Todos"
                />
              </span>
            </div>
          </Col>
        </Row>
      </div>
    )
  }

  renderGridHistoricoTablet = () => {
    return <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Contribuição</TableCell>
            <TableCell>Tipo Alteração</TableCell>
            <TableCell>Data Modificação</TableCell>
            <TableCell>Início vig.</TableCell>
            <TableCell>Fim vig.</TableCell>
            <TableCell className="number-money">Valor {this.state.parametros.contribuicaoValorAbsoluto ? '(R$)' : '%'}</TableCell>
            <TableCell>Informações</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {this.renderGridHistoricoRowIterator(this.renderGridHistoricoSingleRowTablet)}
        </TableBody>
      </Table>
    </TableContainer>
  }

  renderGridHistoricoSingleRowTablet = (element) => {
    return <TableRow>
      <TableCell>{element.tipoMovimento.nomeResumido}</TableCell>
      <TableCell>{element.tipoAlteracaoContribuicao}</TableCell>
      <TableCell>{moment(element.dataAlteracao).format("DD/MM/YYYY")}</TableCell>
      <TableCell>{element.dataInicioVigencia}</TableCell>
      <TableCell>{element.dataFimVigencia}</TableCell>
      <TableCell className="number-money">{
        this.state.parametros.contribuicaoValorAbsoluto ?
          `R$${numberFormatter.format(element.valorAtual)}` :
          `${numberFormatter.format(element.valorAtual)}%`
      }</TableCell>
      <TableCell>
        <OverlayTrigger placement="bottom"
          overlay={
            <Tooltip className="historico-alteracao-tooltip-container">
              <div className="historico-alteracao-tooltip">
                <b>Alteração</b>: {moment(element.dataAlteracao).format("DD/MM/YYYY")}<br />
                <b>Início Vigência</b>: {moment(element.dataInicioVigencia).format("DD/MM/YYYY")}<br />
                <b>Motivo</b>: {element.motivoAlteracao}<br />
                <b>Usuário</b>: {element.usuarioAlteracao}<br />
                {
                  this.state.parametros.contribuicaoValorAbsoluto &&
                  <span><b>Meses contratados</b>: {this.renderMesesHistoricoAlteracao(element.mesesContratacao)}</span>
                }
              </div>
            </Tooltip>
          }>
          <Button className="alterar-contribuicao-info-icon">
            <FontAwesome.FontAwesomeIcon icon={faInfoCircle} className="info-circle-icon" />
          </Button>
        </OverlayTrigger>
      </TableCell>
    </TableRow>
  }

  renderGridHistoricoDesktop = () => {
    return <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Contribuição</TableCell>
            <TableCell>Tipo Alteração</TableCell>
            <TableCell>Data Modificação</TableCell>
            <TableCell>Início vig.</TableCell>
            <TableCell>Fim vig.</TableCell>
            <TableCell className="number-money">Valor {this.state.parametros.contribuicaoValorAbsoluto ? '(R$)' : '%'}</TableCell>
            {this.state.parametros.contribuicaoValorAbsoluto && <TableCell>Meses contratados</TableCell>}
            <TableCell>Informações</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {this.renderGridHistoricoRowIterator(this.renderGridHistoricoSingleRowDesktop)}
        </TableBody>
      </Table>
    </TableContainer>
  }

  renderGridHistoricoRowIterator = (handleRow) => {
    if (!this.state.historicoAlteracoes) {
      return;
    }
    return this.state.historicoAlteracoes.data.map(handleRow)
  }

  renderGridHistoricoSingleRowDesktop = (element) => {
    return <TableRow>
      <TableCell>{element.tipoMovimento.nomeResumido}</TableCell>
      <TableCell>{element.tipoAlteracaoContribuicao}</TableCell>
      <TableCell>{moment(element.dataAlteracao).format("DD/MM/YYYY")}</TableCell>
      <TableCell>{moment(element.dataInicioVigencia).format("DD/MM/YYYY")}</TableCell>
      <TableCell>{moment(element.dataFimVigencia).format("DD/MM/YYYY")}</TableCell>
      <TableCell className="number-money">{
        this.state.parametros.contribuicaoValorAbsoluto ?
          `R$${numberFormatter.format(element.valorAtual)}` :
          `${numberFormatter.format(element.valorAtual)}%`
      }</TableCell>
      {this.state.parametros.contribuicaoValorAbsoluto && <TableCell>{this.renderMesesHistoricoAlteracao(element.mesesContratacao)}</TableCell>}
      <TableCell>
        <OverlayTrigger placement="bottom"
          overlay={
            <Tooltip className="historico-alteracao-tooltip-container">
              <div className="historico-alteracao-tooltip">
                <b>Alteração</b>: {moment(element.dataAlteracao).format("DD/MM/YYYY")}<br />
                <b>Início Vigência</b>: {moment(element.dataInicioVigencia).format("DD/MM/YYYY")}<br />
                <b>Motivo</b>: {element.motivoAlteracao}<br />
                <b>Usuário</b>: {element.usuarioAlteracao}<br />
              </div>
            </Tooltip>
          }>
          <Button className="alterar-contribuicao-info-icon">
            <FontAwesome.FontAwesomeIcon icon={faInfoCircle} className="info-circle-icon" />
          </Button>
        </OverlayTrigger>
      </TableCell>
    </TableRow>
  }

  renderGridHistoricoMobile = () => {
    return <div className="grid-historico-mobile">
      {this.renderGridHistoricoRowIterator(this.renderGridHistoricoSingleRowMobile)}
    </div>
  }

  renderGridHistoricoSingleRowMobile = (element) => {
    return <Row>
      <Col sm={1}>
        <div className='card-row'>
          <div className='card-cell contribuicao'>
            <div className="card-cell-title">Contribuição:</div>
            <div className="card-cell-value"> {element.tipoMovimento.nomeResumido}</div>
          </div>
        </div>
      </Col>
      <Col sm={1}>
        <div className='card-row'>
          <div className='card-cell alteracao'>
            <div className="card-cell-title">Tipo Alteração:</div>
            <div className="card-cell-value"> {element.tipoAlteracaoContribuicao}</div>
          </div>
        </div>
      </Col>
      <Col sm={1}>
        <div className='card-row'>
          <div className='card-cell valor'>
            <div className="card-cell-title">Valor {this.state.parametros.contribuicaoValorAbsoluto ? '(R$)' : '%'} :</div>
            <div className="card-cell-value">{
              this.state.parametros.contribuicaoValorAbsoluto ?
                `R$${numberFormatter.format(element.valorAtual)}` :
                `${numberFormatter.format(element.valorAtual)}%`
            }</div>
          </div>
        </div>
      </Col>
      {
        this.state.parametros.contribuicaoValorAbsoluto &&
        <Col sm={1}>
          <div className='card-row'>
            <div className='card-cell meses-contratados'>
              <div className="card-cell-title">Meses Contratados:</div>
              <div className="card-cell-value"> {this.renderMesesHistoricoAlteracao(element.mesesContratacao)}</div>
            </div>
          </div>
        </Col>
      }
      <Col sm={1}>
        <div className='card-row'>
          <div className='card-cell alteracao'>
            <div className="card-cell-title">Alteração:</div>
            <div className="card-cell-value"> {moment(element.dataAlteracao).format("DD/MM/YYYY")}</div>
          </div>
        </div>
      </Col>
      <Col sm={1}>
        <div className='card-row'>
          <div className='card-cell alteracao'>
            <div className="card-cell-title">Início Vigência:</div>
            <div className="card-cell-value"> {moment(element.dataInicioVigencia).format("DD/MM/YYYY")}</div>
          </div>
        </div>
      </Col>
      <Col sm={1}>
        <div className='card-row'>
          <div className='card-cell alteracao'>
            <div className="card-cell-title">Motivo:</div>
            <div className="card-cell-value"> {element.motivoAlteracao}</div>
          </div>
        </div>
      </Col>
      <Col sm={1}>
        <div className='card-row'>
          <div className='card-cell alteracao'>
            <div className="card-cell-title">Usuário:</div>
            <div className="card-cell-value"> {element.usuarioAlteracao}</div>
          </div>
        </div>
      </Col>
    </Row>
  }

  renderMesesHistoricoAlteracao = arrMeses => {
    return arrMeses.map((b, idx) => {
      return b ? this.mesesSigla[idx] : '';
    }).filter(m => m !== '').join(", ")
  }

  render() {
    return (
      <div className="meu-plano-alterar-contribuicao">
        {isTablet && <ContainerTitle>MEU PLANO | <span className="meu-plano-alterar-contribuicao-subtitle-container">ALTERAR CONTRIBUIÇÃO</span></ContainerTitle>}
        <Row className="meu-plano-alterar-contribuicao-title-container">
          <Col sm={isTablet ? 6 : 8}>
            {!isMobile && <ContainerTitle>MEU PLANO | <span className="meu-plano-alterar-contribuicao-subtitle-container">ALTERAR CONTRIBUIÇÃO</span></ContainerTitle>}
            {isMobileOnly && <ContainerTitle>MEU PLANO <br /> <span className="meu-plano-alterar-contribuicao-subtitle-container">ALTERAR CONTRIBUIÇÃO</span></ContainerTitle>}
            {isMobileOnly && <img src={process.env.PUBLIC_URL + '/alterar-contribuicao-subtitle.png'} className="alterar-contribuicao-subtitle" alt="" />}
            {
              !this.state.parametros.contribuicaoValorAbsoluto &&
              this.renderResumoParametrosContribuicaoPercentual()
            }
            {
              this.state.parametros.contribuicaoValorAbsoluto &&
              this.renderResumoParametrosContribuicaoValorAbsoluto()
            }
            {
              this.state.parametros.contribuicaoValorAbsoluto &&
              this.renderEdicaoContribuicaoNormalValorAbsoluto()
            }
          </Col>
          <Col sm={isTablet ? 6 : 4}>
            {!isMobileOnly && <img src={process.env.PUBLIC_URL + '/alterar-contribuicao-subtitle.png'} className="alterar-contribuicao-subtitle" alt="" />}
          </Col>
        </Row>
        <div className={this.state.parametros.contribuicaoValorAbsoluto ? "edicao-valor-absoluto" : "edicao-valor-percentual"}>
          <div className={!isMobile ? "contribuicao-container-desktop" : ""}>
            {this.state.parametros.contribuicaoValorAbsoluto && <div className="contribuicao-divisor"></div>}
            {
              !this.state.parametros.contribuicaoValorAbsoluto &&
              this.renderEdicaoContribuicaoNormalPercentual()
            }
            {
              false &&
              <div className="contribuicao-voluntaria">
                <SessionTitle className="contribuicao-voluntaria-title">CONTRIBUIÇÃO VOLUNTÁRIA</SessionTitle>
                <div className="contribuicao-voluntaria-session-edit">
                  {
                    !this.state.parametros.contribuicaoValorAbsoluto &&
                    this.renderEdicaoContribuicaoVoluntariaPercentual()
                  }
                  {
                    this.state.parametros.contribuicaoValorAbsoluto &&
                    this.renderEdicaoContribuicaoVoluntariaValorAbsoluto()
                  }
                </div>
              </div>
            }
          </div>
        </div>
        <div className="contribuicao-divisor"></div>
        <Row>
          {!isTablet && <Col sm={5}></Col>}
          <Col sm={isTablet ? 12 : 4}>
            {
              !this.state.parametros.contribuicaoValorAbsoluto &&
              <DeclaracaoSubtitle className="total">
                TOTAL GERAL: <NumberFormat
                  value={this.state.parametros.contribuicaoAtualNormal + ( true ? 0 : this.state.parametros.contribuicaoVoluntaria)}
                  displayType={"text"}
                  thousandSeparator="."
                  decimalSeparator=","
                  decimalScale={2}
                  fixedDecimalScale={true}
                  prefix={"R$ "}
                />
              </DeclaracaoSubtitle>
            }
          </Col>
        </Row>
        <Row>
          {!isTablet && <Col sm={3}></Col>}
          <Col sm={isTablet ? 6 : 3}>
            <FullSizedButton
              type="submit"
              className="alterar-contribuicao-salvar-button"
              variant="contained"
              onClick={this.salvarParametrosContribuicao}
              disabled={!this.state.parametros.periodoAlteracaoContribuicao}>
              <FontAwesome.FontAwesomeIcon icon={faSave} className="alterar-contribuicao-salvar-icon" />
              <span className="alterar-contribuicao-salvar-label">SALVAR ALTERAÇÕES</span>
            </FullSizedButton>
            {
              !this.state.parametros.periodoAlteracaoContribuicao &&
              <div>
                * Não está no período de alteração de contribuição.
              </div>
            }
          </Col>
          <Col sm={isTablet ? 6 : 3}>
            <FullSizedButton
              type="submit"
              className="alterar-contribuicao-voltar-button"
              variant="contained"
              onClick={() => this.navigateTo('/app/meu-plano')}>
              <FontAwesome.FontAwesomeIcon icon={faArrowLeft} className="alterar-contribuicao-voltar-icon" />
              <span className="alterar-contribuicao-voltar-label">VOLTAR AO MENU ANTERIOR</span>
            </FullSizedButton>
          </Col>
        </Row>
        {
          !this.state.parametros.contribuicaoValorAbsoluto &&
          <DeclaracaoSubtitle>
            Lembre-se: <span className="alteracao-contribuicao-historico-lembre-se">a contribuição normal de Patrocinador corresponde à contribuição normal de Participante.
              Quanto maior a sua contribuição, maior será a do Patrocinador e, maior será o seu saldo de conta. Invista no seu futuro!
            </span>
          </DeclaracaoSubtitle>
        }
        <div className="historico-alteracao-contribuicoes">
          <div className="">
            <h4>Histórico de Alterações</h4>
          </div>
          {!isMobile && this.renderGridHistoricoDesktop()}
          {isMobileOnly && this.renderGridHistoricoMobile()}
          {isTablet && this.renderGridHistoricoTablet()}
        </div>
      </div>
    )
  }
}

const mapStateToProps = (store) => ({
  authData: store.authState,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({
    startLoadingAnimate,
    stopLoadingAnimate
  }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(withSnackbar(MeuPlanoAlterarContribuicao)));
